import React, {Component} from 'react';
import {close_popup, show_popup, on_interstate_exit} from "../functions";
import {gTagClickEventValue} from "./frontend_script";
import $ from 'jquery';

class BookingChoisePage extends Component {
	constructor(props) {
		super(props);
		this.onChange = this.onChange.bind(this);
		this.onReset = this.onReset.bind(this);
	}

	componentDidMount(prevProps) {
		if(window.mini_form_hire == 'interstate' && (window.mini_form_submit == true || window.mini_form_data == true)) {
			$(window).on('mouseout', on_interstate_exit);
		}
	}

	onChange(hire) {
		try {
			gTagClickEventValue((hire === 'local' ? 'click_to_switch' : 'click_to_switch_interstate'), {'event_category': 'booking', 'event_label': 'booking-switch'});
		}
		catch (e) {
			console.log(e);
		}
		gTagClickEventValue('click', {'event_category': 'booking', 'event_label': 'booking-switch'});

		if (this.props.hire !== hire && this.props.hire !== '') {
			let content =
				<div className="row error-booking-popup">
					<div className="col-12 text-center">
						<div className="row m-3">
							<div className="col-12 text-center gray">
								<h4>Confirm</h4>
								<br/>
								Are You Sure?
								<br/>
								All changes will be lost.
							</div>
						</div>
						<div className="row mb-3">
							<div className="col-12 text-center">
								<button type="button" className="btn btn-secondary" onClick={close_popup}>CANCEL</button>&nbsp;
								<button type="button" className="btn btn-success" onClick={() => this.onReset(hire)}>SURE</button>
							</div>
						</div>
					</div>
				</div>;
			show_popup(content, {auto_close: false});
		}
		else if(this.props.hire === '') {
			this.onReset(hire);
		}

		if (hire == 'local') {
			$(window).off('mouseout', on_interstate_exit);
		}
		else if (hire == 'interstate') {
			$(window).on('mouseout', on_interstate_exit);
		}
	}

	onReset(hire) {
		let div = '';
		if (hire === 'local')
			div = 'id_search_form_local_div';
		else if (hire === 'interstate')
			div = 'id_search_form_interstate_div';

		this.props.handleSetSomeBlock('scroll_to_element', div);
		this.props.handleSetSomeBlock('category_group_filter', 0);

		this.props.handleSetHire(hire);
		close_popup();
	}

	render() {
		return (
			<div>
				<h2>Where would you like to go?</h2>
				<div className="row justify-content-center my-4" style={{}}>
					<div className="col-auto">
						<button type="button" style={{marginBottom: "10px"}} className={'btn col  btn btn-green-border '+(this.props.hire == 'local' ? 'active' : '')} onClick={() => this.onChange('local')}>
							<i className={'fa fa-truck'}></i> Local Hire
						</button>
					</div>
					<div className="col-auto">
						<button type="button" style={{marginBottom: "10px"}} className={'btn col btn-green-border '+(this.props.hire == 'interstate' ? 'active' : '')} onClick={() => this.onChange('interstate')}>
							<i class={'fa fa-car'}></i> Interstate Hire
						</button>
					</div>
				</div>
			</div>
		);
	}
}

export default BookingChoisePage;